import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { IonicModule } from '@ionic/angular'

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { IonicStorageModule } from '@ionic/storage-angular';
import { InterceptorService } from './app/services/_core/interceptor/interceptor.service';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { CartService } from './app/services/cart/cart.service';
import {
  LucideAngularModule,
  ArrowUpRight,
  File,
  Home,
  Menu,
  UserCheck,
  FileX,
  CircleX,
  GitCompare,
  Link,
  Link2,
  PackageOpen,
  Users,
  UserRoundCog,
  BookText,
  NotebookPen,
  FolderKanban,
  ListFilter,
  BookX,
  SearchX,
  ClipboardCopy,
  ClipboardPaste,
  GraduationCap
} from 'lucide-angular';
function cartStorageInitializer(cart: CartService): () => Promise<void> {
  return () => cart.hydrateFromStorage();
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: cartStorageInitializer,
      deps: [CartService]
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    importProvidersFrom(
      LucideAngularModule.pick({
        File,
        FileX,
        Home,
        Menu,
        UserCheck,
        CircleX,
        GitCompare,
        PackageOpen,
        Users,
        UserRoundCog,
        BookText,
        NotebookPen,
        FolderKanban,
        ListFilter,
        BookX,
        SearchX,
        ClipboardCopy,
        ClipboardPaste,
        GraduationCap
      })
    ),
    provideHttpClient(),
    provideIonicAngular(),
    importProvidersFrom(IonicStorageModule.forRoot()),
    importProvidersFrom(IonicModule),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideEnvironmentNgxMask(),
  ],
});
